/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./tpv-loader";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
import * as i4 from "../services";
import * as i5 from "../../../globals";
import * as i6 from "ionic-angular/components/loading/loading-controller";
import * as i7 from "../../configuration/services";
import * as i8 from "../../takeaway/services";
var styles_TpvLoaderPage = [];
var RenderType_TpvLoaderPage = i0.ɵcrt({ encapsulation: 2, styles: styles_TpvLoaderPage, data: {} });
export { RenderType_TpvLoaderPage as RenderType_TpvLoaderPage };
export function View_TpvLoaderPage_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_TpvLoaderPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-tpv-loader", [], null, null, null, View_TpvLoaderPage_0, RenderType_TpvLoaderPage)), i0.ɵdid(1, 49152, null, 0, i1.TpvLoaderPage, [i2.NavController, i3.NavParams, i4.TPVServices, i5.Globals, i6.LoadingController, i7.ConfigurationServices, i8.TakeawayServices], null, null)], null, null); }
var TpvLoaderPageNgFactory = i0.ɵccf("page-tpv-loader", i1.TpvLoaderPage, View_TpvLoaderPage_Host_0, {}, {}, []);
export { TpvLoaderPageNgFactory as TpvLoaderPageNgFactory };
//# sourceMappingURL=tpv-loader.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/tpv/tpv-loader/tpv-loader.ngfactory.js
// module id = null
// module chunks = 